export default "__VITE_ASSET__Cx5Ry0bz__"